import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ActionButtonDialog from "../Components/ActionButtonDialog";

import UpdateIcon from "@mui/icons-material/Update";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import { makeItemId } from "../tools";
import AppContext from "../appContext";

function ConflictDialog({
  open,
  optionId,
  questionList,
  setOpen,
  saveMutation,
  from,
}) {
  const history = useHistory();
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { t } = useTranslation();
  const overwriteFunc = () => {
    // update survey (keep itemId)
    const data = {
      clientId,
      interactionId: questionList.itemId,
      interactionJSON: JSON.stringify(questionList),
      install: ["send", "install"].includes(optionId),
      projectId,
      sessionId,
    };
    saveMutation.mutate({ data, type: optionId });
  };
  const createFunc = () => {
    // create new survey (make a new itemId)
    const data = {
      clientId,
      interactionId: "new",
      interactionJSON: JSON.stringify({
        ...questionList,
        itemId: makeItemId(),
      }),
      install: ["send", "install"].includes(optionId),
      projectId,
      sessionId,
    };
    saveMutation.mutate({ data, type: optionId });
  };
  const keepFunc = () => {
    // open the local survey for client
    if (from === "editor") {
      history.replace({
        state: {
          interactionId: questionList.itemId,
          interaction: null,
          type: "RELOAD_EDITOR",
        },
      });
    } else {
      history.push({
        pathname: "/editor",
        state: {
          interactionId: questionList.itemId,
          interaction: null,
        },
      });
    }
    setOpen((prev) => ({ ...prev, open: false })); // close the dialog
  };

  return (
    <ActionButtonDialog
      open={open}
      setOpen={setOpen}
      dialogTitle={t("interactions.saveConflictDialog.title", {
        survey: questionList.fullQuestion,
      })}
      dialogContentText={t("interactions.saveConflictDialog.text")}
      buttons={[
        {
          id: "update",
          primaryText: t("interactions.saveConflictDialog.update"),
          icon: <UpdateIcon />,
          onClick: overwriteFunc,
        },
        {
          id: "create",
          primaryText: t("interactions.saveConflictDialog.copy"),
          icon: <AddCircleOutlineOutlinedIcon />,
          onClick: createFunc,
        },
        {
          id: "keep",
          primaryText: t("interactions.saveConflictDialog.view"),
          icon: <VisibilityOutlinedIcon />,
          onClick: keepFunc,
        },
      ]}
    />
  );
}

export default ConflictDialog;
